import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  listRow,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { UserDTO, SimpleUserDTO } from 'BaseDataTypes';
import { LogService } from 'BaseServices/log-service';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  PlantDetailDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { PlantDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/plant-dialog/plant-dialog.component';
import { forkJoin } from 'rxjs';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-plant-view',
  imports: [BaseListPageComponent],
  templateUrl: './plant-view.component.html',
  styleUrl: './plant-view.component.css',
})
export class PlantViewComponent {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = [
    'Navn',
    'Hwp Navn',
    'Kunde',
    'Projektleder',
    'Process Ingeniør',
    'PLC Ingeniør',
  ];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<PlantSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  users: SimpleUserDTO[] = [];
  constructor(
    private mainService: MainService,
    private logService: LogService,
    private userService: UserService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale');
  }
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.updateListAgreements();
  }
  updateMultiSelectFilterLists() {
    var list: multiSelectFilterList[] = [];
    var nameList: multiSelectFilterList = {
      Items: this.plants.map((p) => ({
        name: p.plantName,
        id: p.id,
      })),
      selectedItemsIds: this.plants.map((p) => p.id),
      placeHolderText: 'Vælg Anlæg',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        return plant != null && this.selectedItemsIds.includes(plant.id);
      },
      HideWithHeaderIndex: 0,
    };
    list.push(nameList);
    var hwcList: multiSelectFilterList = {
      Items: this.plants
        .filter((p) => p.hwpPlantName)
        .map((p) => ({
          name: p.hwpPlantName,
          id: p.id,
        })),
      selectedItemsIds: this.plants.map((p) => p.id),
      placeHolderText: 'Vælg HWP navn',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        return (
          (plant != null && !plant.hwpPlantName) ||
          this.selectedItemsIds.includes(plant.id)
        );
      },
      HideWithHeaderIndex: 1,
    };
    list.push(hwcList);

    var clientList: multiSelectFilterList = {
      Items: this.clients.map((c) => ({ name: c.name, id: c.id })),
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        if (!plant) return false;
        if (!plant.clientName) return false;
        const match = this.Items.find((i: any) => i.name === plant.clientName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 2,
    };
    list.push(clientList);

    var projectManagerList: multiSelectFilterList = {
      Items: this.users.map((u) => ({ name: u.name, id: u.id })),
      selectedItemsIds: this.users.map((u) => u.id),
      placeHolderText: 'Vælg Projektleder',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        if (!plant) return false;
        if (!plant.projectManagerName) return true;
        const match = this.Items.find((i: any) => i.name === plant.projectManagerName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 3,
    };
    list.push(projectManagerList);

    var processEngineerList: multiSelectFilterList = {
      Items: this.users.map((u) => ({ name: u.name, id: u.id })),
      selectedItemsIds: this.users.map((u) => u.id),
      placeHolderText: 'Vælg Process ingeniør',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        if (!plant) return false;
        if (!plant.processEngineerName) return true;
        const match = this.Items.find((i: any) => i.name === plant.processEngineerName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 4,
    };
    list.push(processEngineerList);

    var plcEngineerList: multiSelectFilterList = {
      Items: this.users.map((u) => ({ name: u.name, id: u.id })),
      selectedItemsIds: this.users.map((u) => u.id),
      placeHolderText: 'Vælg PLC Ingeniør',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (plant: PlantSummaryDTO) {
        if (!plant) return false;
        if (!plant.plcEngineerName) return true;
        const match = this.Items.find((i: any) => i.name === plant.plcEngineerName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 5,
    };
    list.push(plcEngineerList);

    this.multiSelectFilterLists = list;
  }
 agreementClicked = (plant?: PlantSummaryDTO) => {
  const clientId = plant?.clientName
    ? this.clients.find((c) => c.name === plant.clientName)?.id ?? 0
    : 0;

  const projectManagerId = plant?.projectManagerName
    ? this.users.find((u) => u.name === plant.projectManagerName)?.id ?? null
    : null;

  const processEngineerId = plant?.processEngineerName
    ? this.users.find((u) => u.name === plant.processEngineerName)?.id ?? null
    : null;

  const plcEngineerId = plant?.plcEngineerName
    ? this.users.find((u) => u.name === plant.plcEngineerName)?.id ?? null
    : null;

  const plantRequest: PlantDetailDTO = {
    id: plant?.id ?? 0,
    plantName: plant?.plantName ?? '',
    hwpPlantName: plant?.hwpPlantName,
    clientId,
    projectManagerId,
    processEngineerId,
    plcEngineerId,
    components: [],
    features: [],
    jobs: [],
    agreements: [],
  };

  const dialogRef = this.dialog.open(PlantDialogComponent, {
    data: { data: [plantRequest] },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result === true) {
      this.updateListAgreements();
    }
  });
};

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListAgreements() {
    forkJoin({
      clients: this.mainService.getAll<ClientSummaryDTO>('client'),
      plants: this.mainService.getAll<PlantSummaryDTO>('plant'),
      users: this.userService.getUserDTOs(),
    }).subscribe(({ clients, plants, users }) => {
      this.clients = clients;
      this.plants = plants;
      this.users = users;
      this.users.unshift({ id: 0, name: 'Ingen', email: '' });
      this.updateMultiSelectFilterLists();

      let listData: listRow<PlantSummaryDTO>[] = [];
      plants.forEach((plant) => {
        listData.push({
          object: plant,
          id: plant.id,
          data: [
            plant.plantName,
            plant.hwpPlantName ?? '',
            plant.clientName ?? '',
            plant.projectManagerName ?? '',
            plant.processEngineerName ?? '',
            plant.plcEngineerName ?? '',
          ],
        });
      });
      this.baseListPage.UpdateListData(listData);
    });
  }
}
